import React from "react";
import WhistleSvg from "../assets/whistle.svg";
import TechnicalSvg from "../assets/technical-time-out.svg";
import RallySvg from "../assets/rally.svg";
import BallSvg from "../assets/volleyball-ball.svg";

const defaultProps = { style: { width: "4vw", height: "4vw" } };

export const makeVolleyballTimelineIcons = (
  imgProps: React.ImgHTMLAttributes<HTMLImageElement> = defaultProps
) => ({
  whistle: <img src={WhistleSvg} alt="Whistle" {...imgProps} />,
  timeout: <img src={TechnicalSvg} alt="Timeout" {...imgProps} />,
  technical_break: (
    <img src={TechnicalSvg} alt="Technical Break" {...imgProps} />
  ),
  race: <img src={RallySvg} alt="Race" {...imgProps} />,
  set_won: <img src={BallSvg} alt="Set Won" {...imgProps} />,
});

const VOLLEYBALL_TIMELINE_ICONS = makeVolleyballTimelineIcons();
export default VOLLEYBALL_TIMELINE_ICONS;
